module.exports = __webpack_public_path__ + "static/3-dfdce3deced35cf32a216b80d212ed62.jpg";